const OTHER_BRAIN_REFUSAL =
  "Calendar mapping is available for roofing_v1 and renovation_v1 Digital Brains only. Change Digital Brain type in Digital Brain Settings.";

export function calendarMappingRefusal(botType) {
  if (botType === "roofing_v2") {
    return "Roofing v2 calendars are not mapped from this page.";
  }
  if (botType === "roofing_v1" || botType === "renovation_v1") {
    return "";
  }
  return OTHER_BRAIN_REFUSAL;
}

export function teamCalendarPutUrl(botType, roofingUrl, renovationUrl) {
  if (calendarMappingRefusal(botType)) {
    return "";
  }
  if (botType === "renovation_v1") {
    return renovationUrl;
  }
  if (botType === "roofing_v1") {
    return roofingUrl;
  }
  return "";
}

export function calendarMappingSubtitle(botType) {
  if (botType === "roofing_v2") {
    return "";
  }
  if (botType === "roofing_v1") {
    return "Map your single team calendar to one GoHighLevel calendar (site visits and phone consults share it).";
  }
  return "Map each team calendar to a GoHighLevel calendar for this location";
}

export function calendarMappingSaveShown(botType) {
  return botType !== "roofing_v2";
}

export function calendarModalErrorAfterRefusal(refusal, previousError) {
  if (typeof refusal === "string" && refusal !== "") {
    return refusal;
  }
  return typeof previousError === "string" ? previousError : "";
}

export function calendarMappingNotice(botType) {
  if (botType === "roofing_v2") {
    return "Roofing v2 calendars are not mapped from this page.";
  }
  return "";
}

export function calendarCapacityNotice(listState) {
  if (listState === "listed") {
    return "A calendar id is not proof of capacity.";
  }
  return "";
}

export function calendarModalErrorForType(botType, previousError) {
  if (botType === "roofing_v2") {
    return "";
  }
  return calendarModalErrorAfterRefusal(calendarMappingRefusal(botType), previousError);
}

export function connectCalendarsHelp() {
  return "Connect Calendars loads calendars from GHL and maps them to team calendars in your Digital Brain settings (requires Location ID and a roofing_v1 or renovation_v1 Digital Brain with team calendars configured). Roofing v2 calendars are not mapped from this page.";
}

export function calendarListRequested(botType) {
  return botType === "roofing_v2" || calendarMappingRefusal(botType) === "";
}

const NOT_CONFIGURED_SENTENCE = "GoHighLevel is not configured.";
const UNAUTHORIZED_SENTENCE = "GoHighLevel calendar list is not authorized.";
const UNAVAILABLE_SENTENCE = "GoHighLevel calendar list is unavailable.";
const EMPTY_SENTENCE = "No GoHighLevel calendars were returned.";
const SAVE_KEY_DETAIL = "Save API key and Location ID first before listing calendars.";

function unavailableList() {
  return { state: "unavailable", sentence: UNAVAILABLE_SENTENCE, calendars: [] };
}

function listedCalendar(item) {
  if (!item || typeof item !== "object" || Array.isArray(item)) {
    return { id: "", name: "" };
  }
  return {
    id: typeof item.id === "string" ? item.id : "",
    name: typeof item.name === "string" ? item.name : "",
  };
}

export function calendarListState(httpStatus, body) {
  const detail = body && typeof body.detail === "string" ? body.detail : "";
  if (httpStatus === 404) {
    return { state: "not_configured", sentence: NOT_CONFIGURED_SENTENCE, calendars: [] };
  }
  if (httpStatus === 400 && detail === SAVE_KEY_DETAIL) {
    return { state: "not_configured", sentence: NOT_CONFIGURED_SENTENCE, calendars: [] };
  }
  if (
    httpStatus === 400
    && (detail.startsWith("Unauthorized (401)") || detail.startsWith("Forbidden (403)"))
  ) {
    return { state: "unauthorized", sentence: UNAUTHORIZED_SENTENCE, calendars: [] };
  }
  if (httpStatus === 200 && body && Array.isArray(body.calendars)) {
    if (body.calendars.length === 0) {
      return { state: "empty", sentence: EMPTY_SENTENCE, calendars: [] };
    }
    return {
      state: "listed",
      sentence: "",
      calendars: body.calendars.map(listedCalendar),
    };
  }
  return unavailableList();
}

export function calendarModalInviteVisible(loading) {
  return loading !== true;
}
